import { fmtNumber } from '@/domain/numbers';

export const FIELD_LABELS = {
  producedTonnes: 'Produsert mengde',
  lineState: 'Linjetilstand',
  engineHours: 'Motortimer',
  idleHours: 'Tomgangstimer',
  fuelLitres: 'Dieselforbruk',
  idleFuelLitres: 'Tomgangsdrivstoff',
  loadedTonnes: 'Lastet mengde',
};

export const UNAVAILABLE_SHORT = {
  no_production: 'Ingen produksjon',
  incomplete: 'Ufullstendig grunnlag',
  fraction_filter: 'Ikke per fraksjon',
  no_engine_hours: 'Ingen motortimer',
  no_production_time: 'Ingen produksjonstid',
  no_data: 'Ingen data',
  no_line_state: 'Ikke målt',
  planned_off: 'Ingen planlagt produksjon',
};

export const PROVENANCE_LABELS = { reported: 'rapportert', estimated: 'estimert', mixed: 'blandet' };

export const DEVIATION_STATUS_LABELS = { open: 'Åpen', reviewing: 'Under vurdering', resolved: 'Avklart' };
export const SEVERITY_LABELS = { high: 'Alvorlig', medium: 'Moderat', info: 'Info' };
export const SOURCE_STATUS_LABELS = { demo: 'Eksempeldata', updated: 'Oppdatert', delayed: 'Forsinket', partial: 'Delvis', error: 'Feil' };
export const COVERAGE_LABELS = { complete: 'Komplett', partial: 'Delvis', missing: 'Mangler', not_applicable: 'Ikke relevant', planned_off: 'Planlagt driftsfri', no_data: 'Ingen data' };
export const DAY_KIND_LABELS = { workday: 'Arbeidsdag', planned_off: 'Planlagt driftsfri', demo_shift: 'Planlagt ekstraskift', no_data: 'Utenfor datavindu' };
export const QUALITY_LABELS = { measured: 'Målt', estimated: 'Anslag', missing: 'Mangler', quarantined: 'Karantene', imported: 'Importert' };
export const ACTIVITY_LABELS = { production: 'Produksjon', loading_out: 'Utlasting', service: 'Service' };
export const MACHINE_TYPE_LABELS = { gravemaskin: 'Gravemaskin', dumper: 'Dumper', hjullaster: 'Hjullaster', servicebil: 'Servicebil' };

/** Formatert verdi for et Metric-objekt (verdi + enhet, eller kort utilgjengelighetstekst). */
export function metricText(metric, { withUnit = true } = {}) {
  if (!metric) return '–';
  if (metric.status === 'unavailable' || metric.value === null) return UNAVAILABLE_SHORT[metric.reason] ?? 'Utilgjengelig';
  const v = fmtNumber(metric.value, metric.decimals);
  return withUnit ? `${v} ${metric.unit}` : v;
}

export function metricNumber(metric) {
  if (!metric || metric.status === 'unavailable' || metric.value === null) return null;
  return fmtNumber(metric.value, metric.decimals);
}

export function pctClass(v, invert = false) {
  if (v === null || v === undefined) return 'text-[var(--hr-muted)]';
  const bad = invert ? v < 0 : v > 0;
  if (Math.abs(v) < 0.05) return 'text-[var(--hr-muted)]';
  return bad ? 'text-[var(--hr-red)]' : 'text-[var(--hr-green)]';
}
